<template>
  <div class="profile-container">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span><i class="el-icon-s-tools"></i> User Setting</span>
      </div>
      <el-row :gutter="20">
        <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
          <el-form :model="userForm" id="userForm" ref="userForm" label-width="150px" size="small" :rules="userFormRules" >
            <el-alert
            v-if="errMsg"
              :title="errMsg"
              type="error"
              show-icon>
            </el-alert>
            <el-form-item label="Email" prop="email">
              <el-input v-model="userForm.email" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item label="Password" prop="password">
              <el-input type="password" v-model="userForm.password" @input="userForm.generate_password=''" autocomplete="off" :show-password="true"></el-input>
              <el-progress :percentage="scorePassword(userForm.password)" :color="colors" :format="formatProgress"></el-progress>
            </el-form-item>
            <el-form-item label="Confirm Password" prop="confirm_password">
              <el-input type="password" v-model="userForm.confirm_password" autocomplete="off" :show-password="true"></el-input>
            </el-form-item>
            <el-form-item label="Generate Password">
              <el-input v-model="userForm.generate_password" class="input-with-select" readonly="readonly">
                <el-button slot="append" icon="el-icon-refresh" @click="generatePassword"></el-button>
              </el-input>
            </el-form-item>
            <el-form-item>
              <el-button :loading="submiting" type="primary" @click="submitUser()">Submit</el-button>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
    </el-card>

    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <el-switch 
          v-model="active2fa" 
          active-text="Turn On Two-Factor Authentication"
          @change="onActive2Factor()"
          ></el-switch>
      </div>
      <div v-if="otpauth">
        <el-row :gutter="20">
          <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
            <div class="text-center"><qr-code :text="otpauth" :size="150" class="qr-code" /></div>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
            <span>Please scan QR Code via Application Google Authenticator and get number to verify</span>
            <el-form label-width="150px" size="small" label-position="top">
              <el-form-item label="Token">
                <el-input type="number" v-model="auth_token"></el-input>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="onVerify2Factor()">Verify</el-button>
              </el-form-item>
            </el-form>
          
          </el-col>
        </el-row>
      </div>
    </el-card>
  </div>
</template>

<script>
import {getUserBy, updateUser, register2Factor, verify2FactorUser, status2Factor} from '@/api/user'
import { mapGetters } from 'vuex'
export default {

  computed:{
    ...mapGetters([
      'uid'
    ])
  },
  data(){
      var validatePass = (rule, value, callback) => {
          if (this.userForm.confirm_password !== '') {
            this.$refs.userForm.validateField('confirm_password');
          }
          callback();
       
    };
    var validatePass2 = (rule, value, callback) => {
      if (value !== this.userForm.password) {
        callback(new Error('Two inputs don\'t match!'));
      } else {
        callback();
      }
    };

    return{
      submiting : false,
      errMsg: '',
      colors: [
          {color: '#f56c6c', percentage: 20},
          {color: '#e6a23c', percentage: 60},
          {color: '#1989fa', percentage: 80},
          {color: '#5cb87a', percentage: 100}
        ],
      userForm:{
        uid: '',
        email: '',
        password: '',
        confirm_password: '',
        generate_password: '',
        role: ''
      },
      userFormRules:{
        email: [{
            required: true,
            message: "Please enter email contact",
            trigger: "blur",
          },
          {
            type: "email",
            message: "Please enter correct email format",
            trigger: ["blur"],
          }],
        password: [{ validator: validatePass, trigger: "blur" }],
        confirm_password: [{ validator: validatePass2, trigger: "blur" }]
     
      },
      active2fa: false,
      otpauth: "",
      auth_token: ""
    }
  },
  methods:{
    formatProgress(percentage) {
      if(percentage < 60){
        return 'Weak'
      }else if(percentage < 80){
        return 'Strong'
      }else if(percentage >= 80){
        return 'Good'
      }
        
    },

    getUserData(){
      getUserBy(this.uid).then(({result, data}) =>{
        if(result){
          this.userForm.uid = data.uid
          this.userForm.email = data.email
          this.userForm.role = data.role
          this.active2fa = data.auth_status ? true : false
        }
      })
    },

    mapData(){
      const formData = {
        email: this.userForm.email,
        password: this.userForm.password,
        role: this.userForm.role
      }
    
      if(!formData.password){
        delete formData.password
      }

      return formData
    },

    updateUser(){
      const formData = this.mapData()
      this.submiting = true
      this.errMsg = ''
      updateUser(this.userForm.uid, formData).then(async ({ result, message}) =>{
        this.submiting = false
        if(result){
          this.$notify({
            title: 'Success',
            message: `Update user successfully`,
            type: 'success',
            duration: 1500
          });
          await this.$store.dispatch('user/getInfo')
        }else{
          this.errMsg = message
        }
      })
    },
    submitUser(){
      
      this.$refs.userForm.validate((valid) => {
        if(valid){
            this.updateUser()
        }else{
          console.log('error submit!!')
          return false
        }
      });
    },


    generatePassword() {
      var length = 16,
          charset = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789!@#$%^&*()_+~`|}{[]\:;?><,./-=",
          retVal = "";
      for (var i = 0, n = charset.length; i < length; ++i) {
          retVal += charset.charAt(Math.floor(Math.random() * n));
      }
      this.userForm.generate_password = retVal
      
    },
    scorePassword(pass) {
        var score = 0;
        if (!pass)
            return score;

        // award every unique letter until 5 repetitions
        var letters = new Object();
        for (var i=0; i<pass.length; i++) {
            letters[pass[i]] = (letters[pass[i]] || 0) + 1;
            score += 5.0 / letters[pass[i]];
        }

        // bonus points for mixing it up
        var variations = {
            digits: /\d/.test(pass),
            lower: /[a-z]/.test(pass),
            upper: /[A-Z]/.test(pass),
            nonWords: /\W/.test(pass),
        }

        var variationCount = 0;
        for (var check in variations) {
            variationCount += (variations[check] == true) ? 1 : 0;
        }
        score += (variationCount - 1) * 10;

        return parseInt(score) > 100 ? 100 : parseInt(score);
    },
    onActive2Factor(){
      if(!this.active2fa){
        this.otpauth = ""
        status2Factor({auth_status: false}).then(({ result })=>{
          if(result){
            this.$message({
              message: 'Close Two Factor Authentication.',
              type: 'success'
            });
          }
        })
      }else{
        register2Factor().then(({result, data})=>{
          if(result){
            this.otpauth = data
          }
        })
      }

    },
    onVerify2Factor(){
      if(!this.auth_token) return false;
      verify2FactorUser({auth_token: this.auth_token}).then(({result})=>{
        if(result){
          this.auth_token = ""
          this.otpauth = ""
          this.getUserData()
          this.$message({
            message: 'Verify Two Factor Authentication successfully.',
            type: 'success'
          });
         
        }
      })

    }
  },
  created(){
    this.getUserData()
  }
}
</script>